import { FC } from 'react';
import { FormProvider } from 'react-hook-form';
import { GeneralHeading } from './GeneralHeading';
import useMeasureStore from './store/useMeasureStore';
import { useGeneral } from './hooks';
import { GeneralForm } from './GeneralForm';
import { GeneralData } from './GeneralData';
import { useParams } from 'react-router-dom';

export const GeneralWrapper: FC = () => {
  const { form } = useGeneral();
  const { id } = useParams();

  const { load } = useMeasureStore();

  return (
    <div className="flex flex-col w-full mb-4 p-10">
      <GeneralHeading status={status} load={load} />

      {id ? (
        <GeneralData load={load} />
      ) : (
        <FormProvider {...form}>
          <GeneralForm />
        </FormProvider>
      )}
    </div>
  );
};
